import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApplicationService } from '@shared/services/administration/application.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { NavService } from '@shared/services/nav.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LegalReviewApplications } from '@shared/models/data/LegalReviewApplication';
import { catchError, finalize } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-legal-portal',
  templateUrl: './legal-portal.component.html',
  styleUrls: ['./legal-portal.component.scss']
})
export class LegalPortalComponent implements OnInit {


  loading: boolean = false;
  dataSource: LegalReviewApplications[];
  displayedColumns: string[];

  constructor(
    private applicationService: ApplicationService,
    private dialog: MatDialog,
    private navService: NavService,
    private snackBar: MatSnackBar
  ) { }


  ngOnInit() {
    this.displayedColumns = ['mastercustomerId', 'firstName', 'middleName', 'lastName', 'birthDate', 'submittedDate', 'memberApplicationTypeName', 'pass', 'reject']
    this.refreshTable();

  }

  refreshTable() {
    this.loading = true;

    this.applicationService.getApplicationsForLegalReview().pipe(
      catchError(error => {
        alert('Error fetching applications.');
        this.dataSource = []; // fallback to empty data
        return of([]); // return a safe fallback observable
      }),
      finalize(() => {
        this.loading = false;
      })
    ).subscribe(applications => {
      this.dataSource = applications;
    });
  }


  pass(application: LegalReviewApplications) {
    this.openConfirmDialog(application.applicationId, true, 'pass');
  }

  reject(application: LegalReviewApplications) {
    this.openConfirmDialog(application.applicationId, false, 'reject')
  }

  openConfirmDialog(applicationId: string, action: boolean, message: string): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '300px',
      height: '25 0px',
      data: { action: action, displayMessage: message }
    });

    dialogRef.afterClosed().subscribe((result: boolean) => {
      if (result != null) {
        this.loading = true;
        this.applicationService.updateLegalReview(applicationId, action).pipe(
          catchError(() => {
            alert("Error in updating application legal status.");
            return of();
          }),
          finalize(() => {
            this.loading = false;
            this.refreshTable();
          })
        ).subscribe(() => {
          this.showSnackbar("Success.");
        })
      }
    });
  }

  viewApplicant(applicantId: string) {
    this.navService.viewApplicant(applicantId)
  }

  showSnackbar(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000, // milliseconds
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }


}
